import React, { useContext, useState } from 'react';
import { CreateMeetingContext } from '../../../../services/create-meeting/create-meeting.context';
import { ImageCropDialog } from '../../../image-crop/image-crop-dialog';
import { SelectImage } from './select-image';

const UploadImageContainer = ({ id }) => {
  const { states } = useContext(CreateMeetingContext);
  const { image, setImage } = states;
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        marginBottom: 32,
      }}
    >
      <SelectImage
        id={id}
        setOpen={setOpen}
        image={image}
        setImage={setImage}
      />
      <ImageCropDialog
        id={id}
        open={open}
        setOpen={setOpen}
        image={image}
        setImage={setImage}
      />
    </div>
  );
};

export default UploadImageContainer;
